// eslint-disable-next-line max-classes-per-file
export class CorporateDisCountDetailPresenter {
  discountAmount: number;

  discountId: string;

  agentId: number;

  totalAmtAfterDiscount: number;

  constructor(res: any) {
    this.discountAmount = res?.discountAmount || 0;
    this.discountId = res?.discountId || "";
    this.agentId = res?.agentId || 0;
    this.totalAmtAfterDiscount = res?.totalAmtAfterDiscount || 0;
  }
}
export class CorporateDisCountPresenter {
  corporate: CorporateDisCountDetailPresenter;

  constructor(res: any) {
    this.corporate = new CorporateDisCountDetailPresenter(res?.corporate);
  }
}

export class HistoryBookingCorporateDiscountPresenter {
  discount: number;

  couponAmount: number;

  constructor(res: any) {
    this.discount = res?.discount || 0;
    this.couponAmount = res?.couponAmount || "";
  }
}
